const isFalsy = (value: unknown): boolean => value === 'false'

const isTruthy = (value: unknown): boolean => value === 'true'

const formatValue = (value: unknown | string): boolean | string | unknown => {
  if (isFalsy(value)) return false

  if (isTruthy(value)) return true

  return value
}

const fixBooleanValues = <T extends Record<string, unknown>>(data: T) => {
  const result = Object.entries(data).map(([key, value]) => {
    return [key, formatValue(value)]
  })

  return Object.fromEntries(result)
}

export default fixBooleanValues
